import React from 'react';
import { BookOpenIcon, CheckCircle2Icon, FileTextIcon, GiftIcon, TrophyIcon, XCircleIcon } from 'lucide-react';
const painPoints = ['Before every session you cannot recall the exact tool order, so you end up improvising.', 'You know how to do wood therapy, but not how to structure a 30, 45 or 60-minute session.', 'You always use the same protocol because you have no others documented.', 'A client asks how many sessions she needs and you cannot answer with confidence.', 'You own the wooden tools, but you do not use them all because you are unsure what each one is for.', 'Your clients improve, but they cannot see it, so they stop coming after two sessions.', 'You do not know how to build a service menu or how to price each treatment.', 'You end up searching "wood therapy abdomen protocol" the night before a session.'];
const tomes = [['VOLUME 1', 'Fundamentals, Anatomy and Tools', 'The scientific and technical base: history, tissue anatomy, the function of every tool, golden rules and a universal 60-minute base protocol.'], ['VOLUME 2', 'Body Sculpting and Aesthetics', 'Protocols for abdomen, flanks, legs, saddlebags and glutes with order, timing, pressure and lymphatic closing. Includes measuring and progress photography.'], ['VOLUME 3', 'Therapeutic and Specialized Protocols', 'Complete 45-minute facial wood therapy protocol for lifting, jawline definition and drainage. Arms and sagging skin. Myofascial release for chronic cervical, dorsal and lower back tension. Post-operative protocols with fibrosis grading. Adaptations for men, pregnancy and older adults.'], ['VOLUME 4', 'Lymphatic Drainage and Postpartum', 'Drainage with wood, fluid retention and a postpartum protocol with safety criteria, diastasis, a 12-session plan and consent forms.'], ['VOLUME 5', 'Session and Program Design', 'Timelines for 30, 45, 60 and 90 minutes, 8 and 12-session programs, service menu, suggested pricing and profitability.'], ['VOLUME 6', 'Marketing, Business and Management', 'A 7-day launch, social media, monthly content, admin, client forms and an action plan for your first 90 days.']];
const bonuses = [{
  title: 'Express Map of Protocols by Goal',
  value: '$19',
  description: 'Find in seconds which protocol to use based on your client goal. Includes a quick table, a 3-question selector and a mobile version.',
  image: 'https://cdn.magicpatterns.com/uploads/qD53YE7fC4tuSQgpfdsPH5/wood-Bono-1.webp'
}, {
  title: 'Pro Safety and Session Preparation Checklist',
  value: '$18',
  description: 'Prepare every session with a safety traffic light, a pressure scale and a professional welcome script.',
  image: 'https://cdn.magicpatterns.com/uploads/kPdZhG3Gf8BmQQQRKuqHXs/wood-Bono-2.webp'
}, {
  title: '21-Day Agenda to Launch Your Wood Therapy Service',
  value: '$17',
  description: 'Organize, publish and get your service ready to sell with simple 10 to 30-minute daily tasks.',
  image: 'https://cdn.magicpatterns.com/uploads/iBeLALY4q61fcr9orHvQ6q/wood-Bono-3.webp'
}, {
  title: 'Professional Client Form Pack for Wellness Clients',
  value: '$12',
  description: 'Intake form, measurement log, subjective progress, consent form and post-session recommendations.',
  image: 'https://cdn.magicpatterns.com/uploads/wEXbdMec1dpgyKgfeYT6S6/wood-Bono-4.webp'
}, {
  title: 'WhatsApp and Instagram Scripts to Sell Wood Therapy',
  value: '$7',
  description: '25 scripts, objection responses, captions and story copy ready to copy and paste.',
  image: 'https://cdn.magicpatterns.com/uploads/6a7FCS2ibLyaxVJEs9ug6i/wood-Bono-5.webp'
}];
export function Features() {
  return <div className="w-full bg-white" data-id="element-5" data-mp="gjft54s3l273">
      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-6" data-mp="giee6p7ynvk3">
        <div className="mx-auto max-w-3xl text-center" data-id="element-7" data-mp="24fm0py3vjnid">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-8" data-mp="24e15055tpyix">
            Recognize the problem
          </p>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-brand-900 md:text-4xl" data-id="element-9" data-mp="1vfphwd461iv8">
            If you are a wellness professional, you are probably dealing with
            some of these problems
          </h2>
        </div>
        <div className="mt-9 grid gap-3 md:grid-cols-2" data-id="element-10" data-mp="2n7wyjdjo8v9m">
          {painPoints.map(point => <div key={point} className="flex gap-3 rounded-xl border border-brand-100 bg-cream p-4" data-id="element-11" data-mp="2s4f0k5nmafi9">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-12" data-mp="2e89sgefzz1a8" />
              <p className="text-sm font-medium leading-relaxed text-gray-700" data-id="element-13" data-mp="12pqns3b46vjp">
                {point}
              </p>
            </div>)}
        </div>
        <p className="mt-10 text-center text-2xl font-black text-brand-600 md:text-3xl" data-id="element-14" data-mp="z8uhsrtvuio9">
          What if all of this were already done for you?
        </p>
      </section>

      <section className="bg-brand-900 px-4 py-12 text-white sm:px-6 md:py-20" data-id="element-15" data-mp="v9byg0hpmfnj">
        <div className="mx-auto max-w-6xl text-center" data-id="element-16" data-mp="196iehnb1u092">
          <div className="inline-flex items-center gap-2 rounded-full bg-brand-800 px-4 py-2 text-xs font-bold tracking-wide text-accent" data-id="element-17" data-mp="147fkcxwlxefv">
            <TrophyIcon className="h-4 w-4" data-id="element-18" data-mp="giwawf1tmvm7" /> THE MOST COMPLETE SYSTEM
            AVAILABLE
          </div>
          <h2 className="mt-5 text-3xl font-black md:text-5xl" data-id="element-19" data-mp="bl36nrk2wbok">
            WOOD THERAPY PRO MEGAPACK™
          </h2>
          <p className="mt-3 text-lg font-semibold text-brand-100 md:text-2xl" data-id="element-20" data-mp="q9zcdhynxcm0">
            6 Volumes + 5 Bonuses — From the first contact to a complete
            business system
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-gray-300 md:text-base" data-id="element-21" data-mp="3tv6f5mzfwjft">
            More than 300 pages of ready protocols, client forms, scripts and
            professional management material — all done for you.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-22" data-mp="1xt332o0dpbtb">
            {[['300+', 'pages', FileTextIcon], ['20+', 'ready protocols', BookOpenIcon], ['8', 'tools mastered', TrophyIcon], ['Forms', 'printable included', CheckCircle2Icon]].map(([value, label, Icon]) => {
            const StatIcon = Icon as typeof FileTextIcon;
            return <div key={label as string} className="rounded-xl bg-brand-800/70 p-4" data-id="element-23" data-mp="1excyct12a1bq">
                  <StatIcon className="mx-auto h-6 w-6 text-accent" data-id="element-24" data-mp="1nwgj01fvmosc" />
                  <p className="mt-2 font-black" data-id="element-25" data-mp="1ntklufbus44y">{value}</p>
                  <p className="text-xs text-brand-100" data-id="element-26" data-mp="2ub7oyjjuwzt8">{label}</p>
                </div>;
          })}
          </div>
          <p className="mt-7 text-sm font-medium leading-loose text-brand-100" data-id="element-27" data-mp="2zd6pzms4jkn0">
            Fundamentals · Body sculpting · Therapeutic work · Drainage and
            postpartum · Sessions and programs · Business and management
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-28" data-mp="2zno8dugh6657">
        <div className="text-center" data-id="element-29" data-mp="2vofd2l5se07j">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-30" data-mp="2vnduzwqcsdgb">
            Your reference library
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-31" data-mp="2lppueq62gbq8">
            The 6 Complete Volumes
          </h2>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-32" data-mp="2gr4y31txqc72">
          {tomes.map(([number, title, description], index) => <article key={number} className={`rounded-2xl border p-6 ${index === 2 ? 'border-accent bg-accent/5' : 'border-brand-100 bg-white'}`} data-id="element-33" data-mp="2cqurpo28djro" data-mpi={index}>
              <p className="text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-34" data-mp="ay6huvv2zy2x">
                {number}
                {index === 2 ? ' · THE VOLUME THAT SETS YOU APART' : ''}
              </p>
              <h3 className="mt-2 text-xl font-black text-brand-900" data-id="element-35" data-mp="y6ypjg8s6gof">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-gray-600" data-id="element-36" data-mp="ke92r9lfh7q9">
                {description}
              </p>
            </article>)}
        </div>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 rounded-xl border border-brand-100 bg-cream p-5 text-xs font-semibold text-brand-800" data-id="element-37" data-mp="ahe6yygjhlfo">
          {['Complete protocols ready to use', 'Printable and digital client forms', 'Step-by-step checklists', 'Material you can hand to clients', 'Readable from tablet or phone'].map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-38" data-mp="1vtnyka1whtjs">
              <CheckCircle2Icon className="h-4 w-4 text-brand-500" data-id="element-39" data-mp="20u39yw2mgqz4" />
              {item}
            </span>)}
        </div>
      </section>

      <section className="bg-brand-50 px-4 py-12 sm:px-6 md:py-20" data-id="element-40" data-mp="25zp86qtvepke">
        <div className="mx-auto max-w-5xl" data-id="element-41" data-mp="25xch9o64x4v7">
          <div className="text-center" data-id="element-42" data-mp="2jrdlgxfuvk2y">
            <p className="text-sm font-bold text-brand-600" data-id="element-43" data-mp="2jsey36cisems">
              Included at no extra cost — Total value: $73 →{' '}
              <span className="text-brand-900" data-id="element-44" data-mp="2eyaqckvfk2kn">FREE with your MegaPack</span>
            </p>
            <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-45" data-mp="2tquo15zt9hup">
              The 5 Strategic Bonuses
            </h2>
          </div>
          <div className="mt-9 space-y-4" data-id="element-46" data-mp="32oogu6yd9td4">
            {bonuses.map((bonus, index) => <article key={bonus.title} className="flex gap-4 rounded-xl border border-brand-100 bg-white p-4 sm:gap-5 sm:p-5" data-id="element-47" data-mp="2ynuv9k8ecqne" data-mpi={index}>
                <img src={bonus.image} alt={`Cover of the bonus: ${bonus.title}`} className="h-24 w-24 shrink-0 rounded-md border border-brand-100 bg-cream object-contain sm:h-32 sm:w-32" data-id="element-48" data-mp="14ad1vglb8zkg" />
                <div className="min-w-0 py-0.5" data-id="element-49" data-mp="13uuynlogn3lh">
                  <div className="flex items-center gap-2" data-id="element-50" data-mp="ywjof9u96r2q">
                    <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent/15" data-id="element-51" data-mp="yz5vz9h596ky">
                      <GiftIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-52" data-mp="1rlqvwyboqr04" />
                    </div>
                    <p className="text-xs font-bold text-brand-600" data-id="element-53" data-mp="1moqp2l70hk7y">
                      BONUS 0{index + 1} ·{' '}
                      <span className="text-gray-400 line-through" data-id="element-54" data-mp="1cwuggg7aubph">
                        {bonus.value}
                      </span>{' '}
                      · FREE
                    </p>
                  </div>
                  <h3 className="mt-2 text-base font-black text-brand-900 sm:text-lg" data-id="element-55" data-mp="25lru260kfkbw">
                    {bonus.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-gray-600" data-id="element-56" data-mp="2cy7nxtqaoauq">
                    {bonus.description}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </section>
    </div>;
}